module.exports = __webpack_public_path__ + "img/chevron-right.93f1ee65.svg";